import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApplicationType } from './use-application-type';

export function useGoBackToPreviousFirstResponderPage(onGoBack?: () => void) {
    const navigate = useNavigate();
    const { isFirstResponder } = useApplicationType();
    const { state } = useLocation();

    return useCallback(
        () => {
            if (isFirstResponder) {
                onGoBack?.();

                // if a state.previousLocationPathname exists, use it to issue a navigation action
                // and pass along the state from a previous page
                if (state?.previousLocationPathname) {
                    navigate(state.previousLocationPathname, {
                        state: { ...state, previousLocationPathname: null },
                    });
                } else {
                    // otherwise use browser history to go back to the previous page.
                    // This works correctly because useAutoNavigateToEvent uses replace: true,
                    // so the intermediate route doesn't pollute the history stack.
                    navigate(-1);
                }
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isFirstResponder, state]
    );
}
